/**
 * Centralized Query Key Factory for Deliverables Domain
 * Strictly scoped by organizationId to prevent cross-tenant cache bleeding.
 */
export const deliverableKeys = {
  all: ['deliverables'] as const,
  campaignAggregates: (orgId: string, campaignId?: string | null) =>
    ['deliverable-aggregates', campaignId, orgId] as const,
  legacyCampaignAggregates: (campaignId?: string | null) =>
    ['deliverable-aggregates', campaignId] as const,
  eventDeliverables: (orgId: string, eventId?: string | null) =>
    ['event_deliverables', eventId, orgId] as const,
  legacyEventDeliverables: (eventId?: string | null) =>
    ['event_deliverables', eventId] as const,
};
